import React from "react";

import { useAppContext } from "@app/helpers/hooks";

import type { ConnectorProps } from "./quick-filters.connect";

import { CheckboxAwardWinnersOnly } from "./checkbox-award-winners-only";
import { CheckboxHasETicket } from "./checkbox-has-eticket";
import { CheckboxIsDirect } from "./checkbox-is-direct";
import { FilterCollapse } from "../filter-collapse";

export const QuickFilters = ({ has_operator_awards }: ConnectorProps) => {
  const { translator, features } = useAppContext();

  return (
    <FilterCollapse title={translator.t("!results.filters.quick.filters")}>
      <CheckboxHasETicket />
      <CheckboxIsDirect />
      {!!features.ENABLE_OPERATOR_AWARDS && !!has_operator_awards && (
        <CheckboxAwardWinnersOnly />
      )}
    </FilterCollapse>
  );
};
